<p-toast></p-toast>

<div class="bank-details-container mt-2">

    <!-- Hidden on Small screens -->
    <!-- Visible on Small screens -->
    <div class="block md:hidden">
        <div *ngIf="loading">
            <div id="pause" class="flex align-items-center justify-content-center">
                <div id="spinner"></div>
            </div>
        </div>
        <div class="landing">
            <div class="header-container">
                <div class="icon">
                    <!-- <mat-icon>menu</mat-icon> -->
                </div>
                <div class="header">
                    <p>{{'WELOCOME_TO'| translate}}</p>
                    <p>{{'MICADA_MOBILE_APPLICATION'| translate}}</p>
                </div>
                <div class="subheader">
                    <p> {{'EFFICIENT_AND_ELEGANT_WAY_TO_VERIFY_SITE'| translate}}</p>
                </div>
            </div>
        </div>
        <div style="padding: 0 1em;">
            <p-card class="mobile-card">
                <div class="mobile_search">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="mobileSearch($any($event.target).value)"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </p-card>
            <p-card styleClass="p-card-shadow my-2 widthFull" *ngFor="let item of mobilePhysicalVerficationApplicationsData"
                (click)="selectPhysicalVerAppln(item)">
                <!-- <table cellspacing="1"> -->
                <table cellspacing="10">
                    <tr>
                        <td class="fontXl"><b>{{'APP_ID'| translate}}</b></td>
                        <td class="fontXl">
                            {{item.AppID}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'DATE_OF_SURVEY'| translate}}</b></td>
                        <td>
                            {{item.RegDate_sort | date:'mediumDate'}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'FARMER_NAME'| translate}}</b></td>
                        <td>
                            {{item.FarmerName}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'VILLAGE'| translate}}</b></td>
                        <td>
                            {{item.Village}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'VENDOR_NAME'| translate}}</b></td>
                        <td>
                            {{item.VendorName}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'SCHEME'| translate}}</b></td>
                        <td>
                            {{item.Scheme}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'AUTOID'| translate}}</b></td>
                        <td>
                            {{item.AutoId}}
                        </td>
                    </tr>
                </table>
            </p-card>
        </div>
    </div>

    <!-- Hidden on small screens -->
    <div class="hidden md:block">
        <p-card styleClass="p-card-shadow" class="dashboardTable">
            <div class="flex justify-content-between flex-wrap card-container purple-container">
                <div class="flex align-items-center justify-content-center">
                    <h5 class="mt-0">{{'MI_PHYSICAL_VERIFICATION_APPLICATIONS'| translate}}</h5>
                </div>
                <div class="flex align-items-center justify-content-center">
                    <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT' | translate}}"
                        icon="pi pi-upload" class="p-button-help m-3"></button>
                        <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                        class="p-button-info ml-3"></button>
                    <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                </div>
            </div>
            <div>
                <p-table #dt [value]="physicalVerficationApplications" [rows]="10" [paginator]="true"
                    [globalFilterFields]="['AppID','registerationDate_filter', 'registerationDate_filter', 'FarmerName','Village', 'VendorName', 'Scheme', 'ProgrammeName', 'Targetdays', 'PendingCompletedDays', 'Status_Ar', 'ApplicantType']"
                    responsiveLayout="scroll" [(selection)]="selectedApplications" [rowHover]="true" dataKey="id"
                    currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                    [showCurrentPageReport]="true" sortField="RegDate_sort" [sortOrder]="1" [loading]="loading">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            <h5 class="m-0">{{'MANAGE_APPLICATIONS' | translate }}</h5>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="{{'SEARCH' | translate}}" />
                            </span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <!-- <th style="width: 3rem">
                                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                            </th> -->
                            <th pSortableColumn="">{{'VIEW_APPLICATION'| translate}}</th>
                            <th pSortableColumn="AppID">{{'APP_ID' | translate}}
                                <p-columnFilter type="text" field="AppID" display="menu"></p-columnFilter>
                                <p-sortIcon field="AppID"></p-sortIcon>
                            </th>
                            <th pSortableColumn="RegDate_sort">{{'DATE_OF_SURVEY' | translate}}
                                <p-columnFilter type="text" field="registerationDate_filter" display="menu"></p-columnFilter>
                                <p-sortIcon field="RegDate_sort"></p-sortIcon>
                            </th>
                            <th pSortableColumn="FarmerName">{{'FARMER_NAME' | translate}}
                                <p-columnFilter type="text" field="FarmerName" display="menu"></p-columnFilter>
                                <p-sortIcon field="FarmerName"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Village">{{'VILLAGE' | translate}}
                                <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                                <p-sortIcon field="Village"></p-sortIcon>
                            </th>
                            <th pSortableColumn="VendorName">{{'VENDOR_NAME' | translate}}
                                <p-columnFilter type="text" field="VendorName" display="menu"></p-columnFilter>
                                <p-sortIcon field="VendorName"></p-sortIcon>
                            </th>
                            <th pSortableColumn="ApplicantType">{{'APPLICANT_TYPE' | translate}}
                                <p-columnFilter type="text" field="ApplicantType" display="menu"></p-columnFilter>
                                <p-sortIcon field="ApplicantType"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Scheme">{{'SCHEME' | translate}}
                                <p-columnFilter type="text" field="Scheme" display="menu"></p-columnFilter>
                                <p-sortIcon field="Scheme"></p-sortIcon>
                            </th>
                            <th pSortableColumn="ProgrammeName">{{'PROGRAMME_NAME' | translate}}
                                <p-columnFilter type="text" field="ProgrammeName" display="menu"></p-columnFilter>
                                <p-sortIcon field="ProgrammeName"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Targetdays">{{'TARGET_DAYS' | translate}}
                                <p-columnFilter type="text" field="Targetdays" display="menu"></p-columnFilter>
                                <p-sortIcon field="Targetdays"></p-sortIcon>
                            </th>
                            <th pSortableColumn="PendingCompletedDays">{{'PENDING_COMPLETED_DAYS' | translate}}
                                <p-columnFilter type="text" field="PendingCompletedDays" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="PendingCompletedDays"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Status_Ar">{{'STATUS_AR'| translate}}
                                <p-columnFilter type="text" field="Status_Ar" display="menu"></p-columnFilter>
                                <p-sortIcon field="Status_Ar"></p-sortIcon>
                            </th>
                            <th *ngIf="!(jeLogin || xenLogin)" pSortableColumn="DARemarks">{{'DA_REMARKS'| translate}}
                                <p-columnFilter type="text" field="DARemarks" display="menu"></p-columnFilter>
                                <p-sortIcon field="DARemarks"></p-sortIcon>
                            </th>
                            <th *ngIf="!(jeLogin || xenLogin || ddAssociateLogin)" pSortableColumn="DMICADARemarks">{{'DMICADA_REMARKS'| translate}}
                                <p-columnFilter type="text" field="DMICADARemarks" display="menu"></p-columnFilter>
                                <p-sortIcon field="DMICADARemarks"></p-sortIcon>
                            </th>
                            <!-- <th pSortableColumn="AutoId">Auto Id
                                <p-columnFilter type="text" field="AutoId" display="menu"></p-columnFilter>
                                <p-sortIcon field="AutoId"></p-sortIcon>
                            </th> -->

                            <!-- <th pSortableColumn="">{{'ACTION' | translate}}</th> -->
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <!-- [ngStyle]="{'background-color': product?.PhyVerificationStatus==1  ? '#e6ffe6' : '#ffffff'}" -->
                        <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                            <!-- <td>
                                <p-tableCheckbox [value]="product"></p-tableCheckbox>
                            </td> -->
                            <td>
                                <button pButton pRipple pTooltip="view application" icon="pi pi-file"
                                    class="p-button-rounded p-button-accent mr-1 btnSize"
                                    (click)="selectFarmerApplication(product)"></button>
                                <!-- <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
                                            (click)="deleteProduct(product)"></button> -->
                            </td>
                            <td>{{product?.AppID}}</td>
                            <td>{{product?.RegDate_sort | date:'mediumDate' }}</td>
                            <td>{{product?.FarmerName}}</td>
                            <td> {{product?.Village}}</td>
                            <td> {{product?.VendorName}}</td>
                            <td> {{product?.ApplicantType}}</td>
                            <td> {{product?.Scheme}}</td>
                            <td> {{product?.ProgrammeName}}</td>
                            <td> {{product?.Targetdays}}</td>
                            <td> {{product?.PendingCompletedDays}}</td>
                            <td> {{product?.Status_Ar}}</td>
                            <td *ngIf="!(jeLogin || xenLogin)"> {{product?.DARemarks}}</td>
                            <td *ngIf="!(jeLogin || xenLogin || ddAssociateLogin)"> {{product?.DMICADARemarks}}</td>
                            <!-- <td> {{product?.AutoId}}</td> -->
                            <!-- <td><button (click)="selectPhysicalVerAppln(product)" pButton pRipple type="button"
                                    label="Fill Details" class="p-button-success mr-2 mb-2"></button></td> -->
                            
                            <!-- <td *ngIf="product?.PhyVerificationStatus==2">
                                <button pButton pRipple type="button" pTooltip="Add-MI-Verification" icon="pi pi-plus"
                                    class="p-button-rounded p-button-text"
                                    (click)="selectPhysicalVerAppln(product)"></button>
                            </td>
                            <td *ngIf="product?.PhyVerificationStatus==1">
                                <button pButton pRipple type="button" pTooltip="Edit-MI-Verification"
                                    (click)="selectPhysicalVerAppln(product)" icon="pi pi-pencil"
                                    class="p-button-rounded p-button-text"></button>
                                <button pButton pRipple type="button" pTooltip="Delete-MI-Verification"
                                    icon="pi pi-times" class="p-button-rounded p-button-text p-button-danger"
                                    (click)="deletePhysicalVerAppln(product)"></button>
                            </td> -->
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <!-- <div class="flex  justify-content-between flex-column ">
                            <p>In total there are {{physicalVerficationApplications ?physicalVerficationApplications.length : 0 }} Details Added.
                        
                            </p> -->
                        <div class="flex align-items-center justify-content-between">
                            {{'IN_TOTAL_THERE_ARE'| translate }} {{physicalVerficationApplications ?
                            physicalVerficationApplications.length : 0 }} {{'DETAILS_ADDED' | translate}}.
                        </div>
                        <div class="flex  justify-content-between flex-column ">
                            <div class="flex">
                                <div
                                    style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                </div>{{'PENDING_MORE_THAN_TWO_DAYS'| translate}}
                            </div>
                            <div class="flex">
                                <div
                                    style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                </div>{{'PENDING_BY_ONE_DAY'| translate}}
                            </div>
                            <div class="flex">
                                <div
                                    style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                </div>{{'APROVED_ON_TIME'| translate}}
                            </div>
                            <div class="flex">
                                <div
                                    style="background-color:#ffb3b3 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                </div>{{'DELAYED_APPROVED'| translate}}
                            </div>
                        </div>

                    </ng-template>
                </p-table>
            </div>
        </p-card>
    </div>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>